// @flow
// import searchActions from './search/actions'

export default {
  setLikeAndCounter({ commit }: ActionContext, isLiked: boolean) {
    commit('setLike', isLiked)
    isLiked ? commit('increaseLikeCount') : commit('decreaseLikeCount')
  },

  showErrorModal({ commit }: ActionContext) {
    commit('setErrorModalIsActive', true)
  },

  hideErrorModal({ commit }: ActionContext) {
    commit('setErrorModalIsActive', false)
  },

  showLoginModal({ state, commit }: ActionContext) {
    commit('setLoginModalIsActive', true)

    // If there is a user set
    if (state.user.isLoggedIn) {
      commit('setUserLoggedOut')
    }
  },

  hideLoginModal({ commit }: ActionContext) {
    commit('setLoginModalIsActive', false)
  },

  // if user was logged in on page load but not on API call
  showWasLoggedInModal({ dispatch }: ActionContext) {
    // Note: this modal really should say something about being
    // logged out and probably no need for creating new account
    // Currently just calls the same Login Modal
    dispatch('showLoginModal')
  },

  // ...searchActions,
}
